import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const EditVehicleLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'EditVehicle' */ './components/EditVehicle')
);

export default (store) => {
	return {
		path: 'transport/vehicles/edit/:id',
		element: <AsyncLoading component={<EditVehicleLazy />} />,
	};
};
